// extracted by mini-css-extract-plugin
export default {"supervisorCurrencyIcon":"uIooIE990H_KLXPFZYaU"};